import { useEffect, useState } from "react";
import AdminListToolkit from "../../components/listing/AdminListToolkit";
import AdminDataModal from "../../components/AdminDataModal";
import type { FormField } from "../../components/AdminDataModal";
import { useMessageModal } from "../../contexts/MessageModalContext";
import { useNavigate } from "react-router-dom";

export default function EmailBodies() {
  const BASE_URL = import.meta.env.VITE_LYRAZONE_BASE_URL;

  const { showModal } = useMessageModal();
  const navigate = useNavigate();
  const [data, setData] = useState<any[]>([]);
  const [selectedRow, setSelectedRow] = useState<any>(null);

  const [modalOpen, setModalOpen] = useState(false);
  const [modalMode, setModalMode] = useState<"add" | "edit" | "view">("add");
  const [activeRow, setActiveRow] = useState<any>(null);

  /* =========================
     FETCH EMAIL BODIES
  ========================= */

  const fetchBodies = async () => {
    try {
      const res = await fetch(`${BASE_URL}/admin/settings/email-bodies`, {
        credentials: "include",
      });

      const result = await res.json();

      if (result.success) {
        setData(result.data);
      }
    } catch (error) {
      console.error("Fetch Email Bodies Error:", error);
    }
  };

  useEffect(() => {
    fetchBodies();
  }, []);

  /* =========================
     DELETE
  ========================= */

  const handleDelete = (row: any) => {
    showModal({
      type: "confirm",
      title: "Delete Email Body",
      message: `Are you sure you want to delete "${row.name}"?`,
      confirmText: "Delete",
      cancelText: "Cancel",
      onConfirm: async () => {
        try {
          const res = await fetch(
            `${BASE_URL}/admin/settings/email-bodies/${row.id}`,
            {
              method: "DELETE",
              credentials: "include",
            },
          );

          const result = await res.json();

          if (result.success) {
            fetchBodies();
            setSelectedRow(null);

            showModal({
              type: "success",
              title: "Deleted",
              message: "Email body deleted successfully.",
              confirmText: "OK",
            });
          }
        } catch (error) {
          console.error("Delete Error:", error);
        }
      },
    });
  };

  /* =========================
     FORM FIELDS
  ========================= */

  const emailBodyFields: FormField[] = [
    { key: "id", label: "ID", colSpan: 2 },

    { key: "name", label: "Body Name", colSpan: 2 },

    {
      key: "body",
      label: "Email Body",
      type: "textarea",
      colSpan: 2,
    },

    { key: "status", label: "Status", colSpan: 2 },
  ];

  const columns = [
    { key: "name", label: "Body Name" },
    { key: "status", label: "Status" },
  ];

  return (
    <div>
      <AdminListToolkit
        title="Email Bodies"
        columns={columns}
        data={data}
        selectedRow={selectedRow}
        extraButtons={[
          {
            label: "Back",
            onClick: () => navigate("/admin/emails"),
          },
        ]}
        onAdd={() => navigate("/admin/email-bodies/create")}
        onView={(row) => {
          setModalMode("view");
          setActiveRow(row);
          setModalOpen(true);
        }}
        onEdit={(row) => navigate(`/admin/email-bodies/edit/${row.id}`)}
        onSoftDelete={handleDelete}
        enableExport={false}
      >
        {(filteredData) => (
          <div className="algorithm-grid">
            {filteredData.map((item: any) => (
              <div
                key={item.id}
                className={`algorithm-card ${
                  selectedRow?.id === item.id ? "selected" : ""
                }`}
                onClick={() => setSelectedRow(item)}
              >
                <h3>{item.name}</h3>

                <p>
                  <strong>Status:</strong>{" "}
                  <span
                    className={
                      item.status === "active"
                        ? "badge-success"
                        : "badge-danger"
                    }
                  >
                    {item.status}
                  </span>
                </p>
              </div>
            ))}
          </div>
        )}
      </AdminListToolkit>

      <AdminDataModal
        isOpen={modalOpen}
        mode={modalMode}
        title="Email Body"
        fields={emailBodyFields}
        rowData={activeRow}
        onClose={() => setModalOpen(false)}
        // onSubmit={}
      />
    </div>
  );
}
